/* BEZELOR cart (phone): open / close the suggestions drop-down. */
(function(){
  document.addEventListener('click',function(e){
    var b=e.target.closest&&e.target.closest('.bzs__toggle');
    if(!b)return;
    var box=b.closest('.bzs--dd');
    if(!box)return;
    var open=!box.classList.contains('is-open');
    box.classList.toggle('is-open',open);
    b.setAttribute('aria-expanded',open?'true':'false');
  });
})();
